import { render, staticRenderFns } from "./LabeledValue.vue?vue&type=template&id=414f3439"
import script from "./LabeledValue.vue?vue&type=script&lang=ts"
export * from "./LabeledValue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports